const FONT_SIZE = 13;
const LINE_HEIGHT = 1.3;

export default {
  FONT_SIZE,
  LINE_HEIGHT
};
